export default __webpack_public_path__ + "static/media/gallery@2x.72c1e88a.png";